module.exports = "/images/10K-YG.webp?ab6a51cb1bed06ab2292e1a774915e29";